import { createSvgIcon } from '@mui/material';

export const LightBulbIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 14.2829V14.8285C8 15.3735 7.82488 16.4982 8.19995 16.8835C8.57502 17.2689 9.46952 17.5 9.99995 17.5C10.5304 17.5 11.4249 17.2689 11.7999 16.8835C12.175 16.4982 12 15.3735 12 14.8285V14.2829M8 14.2829C8 13.3633 7.644 12.4807 7.012 11.8314L6.464 11.2694C5.76487 10.5509 5.2888 9.63549 5.09598 8.63899C4.90316 7.6425 5.00225 6.60964 5.38073 5.671C5.75921 4.73237 6.40007 3.93012 7.22229 3.36569C8.0445 2.80126 9.01115 2.5 10 2.5C10.9889 2.5 11.9555 2.80126 12.7777 3.36569C13.5999 3.93012 14.2408 4.73237 14.6193 5.671C14.9977 6.60964 15.0968 7.6425 14.904 8.63899C14.7112 9.63549 14.2351 10.5509 13.536 11.2694L12.988 11.8314C12.6747 12.1533 12.4262 12.5355 12.2567 12.9562C12.0872 13.3768 11.9999 13.8276 12 14.2829M8 14.2829H9.99995M12 14.2829H9.99995M9.99995 14.2829L10 8.40876H8H12"
      stroke="#D69D61"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'LightBulbIcon',
);
